import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "details_view"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "支付明细", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "关联订单", -1);

const _hoisted_7 = {
  class: "base_details_content_second"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "产品信息", -1);

const _hoisted_9 = {
  class: "base_details_content_second"
};
const _hoisted_10 = ["src"];
import BackTitleView from "@com/BackTitleView.vue";
import useRoute from "@util/router";
import { ref } from "vue";
import api from "@api/finance";
import { $msg } from "@/common/ui/msg";
export default {
  __name: 'detailsView',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    const mainBusiType = ref("");
    const relationConfig = [{
      label: "订单编号",
      prop: "orderCode"
    }, {
      label: "发货方式",
      prop: "deliveryType",
      width: 100
    }, {
      label: "归属基地",
      prop: "shopName",
      width: 140
    }, {
      label: "下单时间",
      prop: "createTime"
    }, {
      label: "付款时间",
      prop: "payTime"
    }, {
      label: "活动优惠",
      prop: "discountMoney"
    }, {
      label: "实付金额",
      prop: "dueMoney"
    }];
    const data = ref({
      list: [],
      payList: [],
      productList: []
    });
    const statusTitle = ref("已完成");
    const mainType = ref("1017001");
    const orderCode = ref(null);
    getData();

    function handleBlur(data) {
      console.log('mainType' + JSON.stringify(mainType));
      console.log('orderCode' + JSON.stringify(orderCode));
      console.log('Input number lost focus' + JSON.stringify(data)); // 在这里处理鼠标移开后的逻辑

      api.costPriceUpdate(mainType.value, data.orderCode, data.skuCode, data.costPrice, () => {
        $msg.succ("修改成功");
        getData();
      });
    }

    function getData() {
      api.details(urlQuery.code, val => {
        statusTitle.value = "已完成";
        val.payList.map(e => {
          switch (e.payType) {
            case "1021001":
              e.payTypeStr = "微信支付";
              break;

            case "1021002":
              e.payTypeStr = "储值支付";
              break;
          }

          e.payMoney = e.payMoney + "¥";
          return e;
        });
        val.list.map(e => {
          mainType.value = e.mainBusiType; // 1017001 商品订单、1017002 旅行订单、1017003 酒店订单、1017004 礼包订单

          switch (e.mainBusiType) {
            case "1017001":
              e.mainBusiType = "商品";
              break;

            case "1017002":
              e.mainBusiType = "旅行";
              break;

            case "1017003":
              e.mainBusiType = "酒店";
              break;

            case "1017004":
              e.mainBusiType = "综合活动";
              break;
          } // 1019001 快递配送、1019002 用户自提


          switch (e.deliveryType) {
            case "1019001":
              e.deliveryType = "快递配送";
              break;

            case "1019002":
              e.deliveryType = "用户自提";
              break;
          }

          return e;
        });
        data.value = val;
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: `订单详情-${statusTitle.value}`
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_table, {
            data: data.value.payList,
            border: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              prop: "transactionNo",
              label: "交易号",
              width: ""
            }), _createVNode(_component_el_table_column, {
              prop: "payMoney",
              label: "金额",
              width: "100"
            }), _createVNode(_component_el_table_column, {
              prop: "payTypeStr",
              label: "支付方式",
              width: "100"
            }), _createVNode(_component_el_table_column, {
              prop: "payTime",
              label: "交易时间",
              width: "180"
            })]),
            _: 1
          }, 8, ["data"])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_table, {
            data: data.value.list,
            border: ""
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(relationConfig, (item, index) => {
              return _createVNode(_component_el_table_column, {
                key: index,
                prop: item.prop,
                label: item.label,
                width: item.width
              }, null, 8, ["prop", "label", "width"]);
            }), 64))]),
            _: 1
          }, 8, ["data"])]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_table, {
            data: data.value.productList,
            border: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "产品图片",
              width: "110",
              align: "center"
            }, {
              default: _withCtx(scope => [_createElementVNode("img", {
                src: scope.row.picUrl,
                style: {
                  width: '75px',
                  height: '75px'
                }
              }, null, 8, _hoisted_10)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              prop: "productName",
              label: "产品名称"
            }), _createVNode(_component_el_table_column, {
              prop: "skuName",
              label: "规格"
            }), _createVNode(_component_el_table_column, {
              prop: "shopName",
              label: "归属基地",
              width: "140"
            }), mainType.value != '1017004' ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "成本价(元)",
              align: "center"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.costPrice,
                "onUpdate:modelValue": $event => scope.row.costPrice = $event,
                modelModifiers: {
                  number: true
                },
                min: 0,
                precision: 2,
                onBlur: $event => handleBlur(scope.row),
                controls: false
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
              _: 1
            })) : _createCommentVNode("", true), mainType.value == '1017004' ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "costPrice",
              label: "成本价(元)",
              width: "80"
            })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
              prop: "duePrice",
              label: "价格",
              width: "80"
            }), _createVNode(_component_el_table_column, {
              prop: "num",
              label: "数量",
              width: "60"
            }), _createVNode(_component_el_table_column, {
              prop: "profitMoney",
              label: "毛利",
              width: "100"
            }), _createVNode(_component_el_table_column, {
              prop: "profitRate",
              label: "毛利率%",
              width: "100"
            })]),
            _: 1
          }, 8, ["data"])])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("关闭")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};